import FixedPoint from './fixed-point';
export default FixedPoint;
